import { Stack, styled, Theme, Typography } from '@mui/material'
import { FC } from 'react'

import { styles } from '@/components/styles'
import { useTranslation } from '@/core'
import { useSafeAreaFooterSetting } from '@/lib/safeAreaView'

const ConsoleFooter: FC = () => {
  useSafeAreaFooterSetting({ safeArea: true })
  const { t } = useTranslation('common')

  return (
    <Stack
      sx={{
        bgcolor: 'grey.50',
        pt: 6,
        pb: (theme: Theme) =>
          `calc(${theme.spacing(6)} + ${styles.safeAreaBottom})`,
      }}
      spacing={3}
      alignItems="center"
    >
      <Stack direction="row" spacing={5} sx={{ maxWidth: '100%' }}>
        <ExternalLink href="https://drive.google.com/file/d/1KF-AUGDh2StRL4OKk4pr2bFhxz-VnSqW/view">
          <Typography color="text.secondary" variant="subtitle1">
            {t('termsOfService')}
          </Typography>
        </ExternalLink>
        <ExternalLink href="https://drive.google.com/file/d/1KF-AUGDh2StRL4OKk4pr2bFhxz-VnSqW/view">
          <Typography color="text.secondary" variant="subtitle1">
            {t('privacyPolicy')}
          </Typography>
        </ExternalLink>
        <ExternalLink href="https://drive.google.com/file/d/1KF-AUGDh2StRL4OKk4pr2bFhxz-VnSqW/view">
          <Typography color="text.secondary" variant="subtitle1">
            {t('companyProfile')}
          </Typography>
        </ExternalLink>
      </Stack>
      <Typography variant="overline" color="text.secondary">
        © 2021 Utoniq,Inc.
      </Typography>
    </Stack>
  )
}

const ExternalLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
}))

export default ConsoleFooter
